export default "__VITE_ASSET__Bd9bPqdl__"